import React from 'react';
import UserLogin from '../../components/User/Login/Login';
import PageDefault from '../../components/PageDefault';

const PagesLogin = () => (
  <PageDefault>
    <UserLogin />
  </PageDefault>
);

export default PagesLogin;
